import { Check, Clear } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { DemandRecommendationFormPropsType } from '../DemandRecommendationForm/DemandRecommendationForm.types';
import { TsrctRecommendationDecisionStatus } from '@/generated/gql/graphql';
import { I18nNamespace } from '~/common/types';

type SelectionButtonProps = Pick<DemandRecommendationFormPropsType, 'value' | 'onChange'>;

export const SelectionButton = ({ value, onChange }: SelectionButtonProps) => {
  const { t } = useTranslation(I18nNamespace.widgets, { keyPrefix: 'DemandRecommendationWidget' });
  const isSelected = value.decisionStatus === TsrctRecommendationDecisionStatus.ACCEPTED;
  return (
    <Button
      color={isSelected ? 'default' : 'success'}
      variant={isSelected ? 'outlined' : 'contained'}
      endIcon={isSelected ? <Clear /> : <Check />}
      onClick={() => {
        onChange({
          decisionStatus: isSelected
            ? TsrctRecommendationDecisionStatus.UNDECIDED
            : TsrctRecommendationDecisionStatus.ACCEPTED,
          id: value.id,
          isDirty: value.decisionStatus === TsrctRecommendationDecisionStatus.UNDECIDED,
        });
      }}
    >
      {isSelected ? t('deselect') : t('select')}
    </Button>
  );
};
